import { SVG, Path } from '@wordpress/primitives';

const cartIcon = (
    <SVG
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
    >
        <Path d="M4.853,7.022L19.147,7.022C19.521,7.022 19.838,7.297 19.89,7.668L21.493,19.146C21.523,19.361 21.458,19.579 21.316,19.742C21.173,19.906 20.967,20 20.75,20L3.25,20C3.033,20 2.827,19.906 2.684,19.742C2.542,19.579 2.477,19.361 2.507,19.146L4.11,7.668C4.162,7.297 4.479,7.022 4.853,7.022ZM5.506,8.522L4.112,18.5L19.888,18.5L18.494,8.522L5.506,8.522Z"/>
        <Path d="M8.956,8.948C8.981,9.361 8.665,9.717 8.251,9.741C7.838,9.765 7.483,9.449 7.459,9.036C7.459,9.036 7.322,6.588 8.237,4.63C8.911,3.188 10.113,2 12.218,2C14.12,2 15.217,3.191 15.815,4.665C16.604,6.608 16.468,9.036 16.468,9.036C16.444,9.449 16.089,9.765 15.675,9.741C15.262,9.717 14.946,9.361 14.97,8.948C14.97,8.948 15.096,6.882 14.425,5.229C14.051,4.306 13.409,3.5 12.218,3.5C10.44,3.5 9.663,4.813 9.292,6.081C8.874,7.515 8.956,8.948 8.956,8.948Z"/>
    </SVG>
);


export default cartIcon;